export default __webpack_public_path__ + "static/media/01n.ce5dd93e.svg";